/**
 * Auto generated file using cli command
 * _> cronos front-enum
 * !! DO NOT EDIT THIS FILE MANUALLY !!
 * Manual changes will be overwritten
 */

export enum MESSAGE_TYPE {
	Infos = 0,
	Warning = 1,
	Urgent = 2,
}
